import { combineEpics } from "redux-observable";
import applicationEpic from "application/redux/applicationEpic";
import authEpic from "auth/authEpic";

export default combineEpics(applicationEpic, authEpic);
